import { Component } from '@angular/core';

@Component({
  selector: 'app-registration-process-main',
  templateUrl: './registration-process-main.component.html',
  styleUrls: ['./registration-process-main.component.css']
})
export class RegistrationProcessMainComponent {
  
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }

}
